import React from 'react';

import {UserAvatar} from 'app/components/general/avatars';
import {SignoffStatusWithButton} from 'app/signoffs/components/SignoffStatusWithButton';

import {SignoffSerializedType} from 'sweet-types';

type Props = {
  signoff: SignoffSerializedType;
};

export function SignoffDocumentHistoryItem({signoff}: Props): JSX.Element {
  return (
    <div className="d-flex small clearfix p-2 border-bottom align-items-center">
      <UserAvatar user={signoff.user} small />
      <div className="ml-2">
        <div>{signoff.user.name}</div>
        <div>
          <SignoffStatusWithButton signoff={signoff} alignment="left" />
        </div>
      </div>
    </div>
  );
}
